module.exports = __webpack_public_path__ + "static/media/details-21-image-2.d5e391eb.jpg";